module.exports = __webpack_public_path__ + "img/call_end.95c1ad4d.svg";